<template>
  <div class="container">
    <div class="fixed-bottom">
      <Transition>
        <div
          class="shadow position-absolute bottom-0 end-0 scroll-to-top rounded-3 d-flex align-items-center me-3 mb-3 me-sm-5 mb-sm-5 pointer"
          @click="scrollToTop"
        >
          <div class="text-center w-100">
            <svg
              viewBox="0 0 16 16"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <use fill="white" href="../assets/svg/arrow-up.svg#arrow-up" />
            </svg>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup>
const scrollToTop = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};
</script>

<style scoped>
.scroll-to-top {
  width: 52px;
  height: 52px;
  color: rgb(0, 0, 0);
  /* background-color: #fc4667; */
  background-color: rgb(255, 255, 255, 0.8);
}

.scroll-to-top:hover {
  background-color: rgb(255, 255, 255, 1);
}
</style>
